import React, { useState } from 'react'
import { useCallback } from 'use-memo-one'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import dynamic from 'next/dynamic'
import { useSelector, useDispatch } from 'react-redux'

import useDidMount from 'utils/didMount'
import Layout from 'components/layouts/signIn'
import { META } from '.config/meta'
import Form from 'components/forms/form'
import { setTask } from 'store/actions/task'
import makeId from 'utils/bson'
const GenericModal = dynamic(() => import('components/modals/generic'), { ssr: false })
const Input = dynamic(() => import('components/forms/input'), { ssr: false })
const Submit = dynamic(() => import('components/buttons/submit'), { ssr: false })

export default function ForgotPassword () {
  const [message, setMessage] = useState(false)
  const user = useSelector((state) => state.user.value)
  const dispatch = useDispatch()

  useDidMount(() => {
    if (typeof user === 'object' && typeof user?.tokenId === 'string') window.open(`https://${window.location.hostname}/profile`, '_self')
  })

  const onSubmit = useCallback((data) => {
    const _id = makeId()
    dispatch(setTask({
      [_id]: {
        type: 'api',
        data: {
          type: 'resetPassword',
          data
        }
      }
    }))
    setMessage('An email was sent to your inbox, please use the link in it and confirm this request.')
    window.setTimeout(() => {
      window.open(`https://${window.location.hostname}/sign-in`, '_self')
    }, 5000)
  }, [])

  const validate = object().shape({
    email: string().email('Please enter correct email').required('Email is required'),
    firstName: string().required('First name is required')
  })

  const formik = useFormik({
    initialValues: { email: '', firstName: '' },
    validationSchema: validate,
    onSubmit
  })

  return (
    <Layout sTitle="Reset password" title={META.forgotPassword.title} description={META.forgotPassword.description} path={META.forgotPassword.path}>
      <Form onSubmit={formik.handleSubmit}>
        <Input
          label="First name"
          name="firstName"
          placeholder="John"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errors={formik.errors.firstName}
          touched={formik.touched.firstName}
          disabled={formik.isSubmitting} />
        <Input
          label="Email"
          name="email"
          placeholder="me@mydomain.com"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errors={formik.errors.email}
          touched={formik.touched.email}
          disabled={formik.isSubmitting} />
        <Submit name="Send" loading={formik.isSubmitting} />
      </Form>

      <GenericModal open={message} setOpen={setMessage} text={message} />
    </Layout>
  )
}
